import React from "react";
import { Instagram, LinkedIn, YouTube } from "@mui/icons-material";

const Footer = () => {
  return (
    <div style={{ fontFamily: 'Raleway, sans-serif' }}>
      <div className="bg-gray-800 text-white p-10 mt-0">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

          {/* Address and Contact Section */}
          <div>
            <h3 className="font-bold mb-3">Address</h3>

            <p className="mb-1">
              <a href="/contact" className="text-white no-underline hover:text-green-400">
                K-151, MIDC, Waluj Chhatrapati Sambhaji Nagar, Maharashtra
              </a>
            </p>

            <p className="mb-1">
              <a href="mailto:www.ecosenseappliances.com" className="text-white no-underline hover:text-green-400">
                www.ecosenseappliances.com
              </a>
            </p>

            <h3 className="font-bold mb-3 text-white">Contact</h3>

            <p className="mb-1">
              <a href="mailto:admin@ecosenseappliances.com" className="text-white no-underline hover:text-green-400">
                admin@ecosenseappliances.com
              </a>
            </p>

            <p className="mb-3">
              <a href="/contact" className="text-white no-underline hover:text-green-400">
                +91- 91588 90105
              </a>
            </p>


            <h3 className="font-bold mb-3">Social</h3>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/_zeropad_?igsh=dzJvOTNyMHZzZ3A3" className="text-white text-2xl hover:text-pink-500">
                <Instagram />
              </a>
              <a href="https://www.linkedin.com/company/ecosense-appliances-pvt-ltd/" className="text-white text-2xl hover:text-blue-700">
                <LinkedIn />
              </a>
              <a href="https://youtube.com/@ecosenseappliances?si=7F1oW0hD8X0w3ka5" className="text-white text-2xl hover:text-red-600">
                <YouTube />
              </a>
            </div>
          </div>

          {/* About & Product Section */}
          <div>
            <h3 className="font-bold mb-2">About</h3>
            <p className="mb-1">
              <a href="/about#zeropad" className="text-white no-underline hover:text-green-400">
              Impact with Zeropad
              </a>
            </p>
            <p className="mb-1">
              <a href="/about#goals" className="text-white no-underline hover:text-green-400">
              Sustainable Development Goals
              </a>
            </p>
            
            <p className="mb-1">
              <a href="/about#teams" className="text-white no-underline hover:text-green-400">
              Meet the Team
              </a>
            </p>
            <p className="mb-1">
              <a href="/about#site" className="text-white no-underline hover:text-green-400">
              Visit Ecosense Appliances
              </a>
            </p>
            

            <h3 className="font-bold mb-2">Product</h3>
           
            <p className="mb-1">
              <a href="/products#features" className="text-white no-underline hover:text-green-400">
              Product Features
              </a>
            </p>
            <p className="mb-1">
              <a href="/products#Benefits" className="text-white no-underline hover:text-green-400">
              Benefits
              </a>
            </p>
            <p className="mb-1">
              <a href="/products#Beneficiary" className="text-white no-underline hover:text-green-400">
              Beneficiary
              </a>
            </p>
            <p className="mb-1">
              <a href="/products#Product" className="text-white no-underline hover:text-green-400">
              Product Details
              </a>
            </p>
            <p className="mb-1">
              <a href="/products#Certification" className="text-white no-underline hover:text-green-400">
              Legal Certification(s)
              </a>
            </p>
            
            
          </div>

          {/* Community & Corporate Section */}
          <div>
            <h3 className="font-bold mb-2">Community</h3>
            <p className="mb-1">
              <a href="/community#Success_Stories" className="text-white no-underline hover:text-green-400">
                Success Stories
              </a>
            </p>

            <p className="mb-1">
              <a href="/community#community-initiatives" className="text-white no-underline hover:text-green-400">
                User Community Initiatives
              </a>
            </p>
           
            <p className="mb-1">
              <a href="/community#Social_Feed" className="text-white no-underline hover:text-green-400">
                Social Feed
              </a>
            </p>

            <p className="mb-1">
              <a href="/community#Educating_the_Society" className="text-white no-underline hover:text-green-400">
                Educating Society
              </a>
            </p>
            <p className="mb-1">
              <a href="/community#Book_Workshop_Session" className="text-white no-underline hover:text-green-400">
                Book Workshop Session
              </a>
            </p>

            <p className="mb-1">
              <a href="/community" className="text-white no-underline hover:text-green-400">
                Community Forum
              </a>
            </p>



            <h3 className="font-bold mb-2">Corporate</h3>
            <p className="mb-1">
              <a href="/corporate#menstrual-waste-section" className="text-white no-underline hover:text-green-400">
                How to get started?
              </a>
            </p>
            <p>
              <a href="/contact" className="text-white no-underline hover:text-green-400">
                Contact Form
              </a>
            </p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Footer;
